/**
 * Texte des Wizards „Neue Kampagne“. Jeder Bereich legt `<bereich>.de.ts` und `<bereich>.en.ts` an
 * (Default-Export: flaches Objekt `{ wizKey: 'Text' }`); sie werden hier gesammelt und in
 * `src/locales/de.ts` / `en.ts` eingemischt.
 */
type LocaleModules = Record<string, { default: Record<string, string> }>;

const merge = (modules: LocaleModules): Record<string, string> =>
  Object.assign({}, ...Object.values(modules).map(m => m.default));

export const wizardDE = merge(import.meta.glob('./*.de.ts', { eager: true }) as LocaleModules);
export const wizardEN = merge(import.meta.glob('./*.en.ts', { eager: true }) as LocaleModules);
